import React, { useEffect, useState } from "react";
import useFetch from "../../fetch/useFetch.js";
import { convertToSlug, nl2br } from "../../components/api";
import Banner from "../Banner/Banner";
import "../About/About.css";
import parse from "html-react-parser";

const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;
const SALONAPI = process.env.REACT_APP_SOMPROP_API_EXTERNAL;
const About = () => {

  const apiUrl = `${SALONAPI}/salonInformation`;

  const { data: aboutData, isPending: aboutPending, serverError: aboutError} = useFetch(apiUrl);

  const [principalsData, setPrincipalsData] = useState(null);
  const [galleryData, setGalleryData] = useState(null);
  const [galleryPending, setGalleryPending] = useState(false);
  const [galleryError, setGalleryError] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const showOverlay = (item) => {
    setSelectedItem(item);
  };

  useEffect(() => {
    if (aboutData) {
      const galleryUrl = `${SALONAPI}/galleryData`;
      fetchGalleryData(galleryUrl);
    }
  }, [aboutData]);

  const fetchGalleryData = (url) => {
    setGalleryPending(true);
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch gallery data");
        }
        return response.json();
      })
      .then((data) => {
        setGalleryData(data);
        setGalleryPending(false);
      })
      .catch((error) => {
        setGalleryError(error.message);
        setGalleryPending(false);
      });
  };




  useEffect(() => {
    if (galleryData && galleryData) {
      // const principalsDiv = galleryData.map((item) => {
      //   const explodedArray = item.gallery_title.split(" @ ");
      //   const name = explodedArray[0];
      //   const title = explodedArray[1];
      //   const email = explodedArray[2];
      //   const phone = explodedArray[3];
      //   const slug = convertToSlug(name);

      const principalsDiv = galleryData.map((item) => {
        const explodedArray = item.gallery_title.split(" @ ");
        const name = explodedArray[0] || 'Somerset Properties';
        const title = explodedArray[1] || 'Somerset Properties';
        const email = explodedArray[2] || 'Somerset Properties';
        const phone = explodedArray[3] || 'Somerset Properties';
        const slug = convertToSlug(name);

        return (
          <div className="col-12 col-sm-6 col-md-6" key={item.gallery_id}>
            <div className="somprop-member-card">
              <div className="sompro-member-inner-card">
                <div className="row gx-md-2">
                  <div className="col-12 col-sm-12 col-md-5 col-md-45">
                    <div className="somprop-img-card">
                      <img
                        src={item.gallery_image}
                        className="img-fluid"
                        width="226"
                        height="249"
                        alt={item.gallery_title}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-7 col-md-55">
                    <div className="somprop-member-info">
                      <h3>{name}</h3>
                      <h4>{title}</h4>
                      <div className="somprop-info-details">
                        <p>
                          <a href={`mailto:${email}`}>{email}</a>
                        </p>
                        <p>
                          <a href={`tel:${phone}`}>{phone}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="somprop-bio-btn"
                  onClick={() => showOverlay(item.gallery_id)}
                >
                  <button
                    data-bs-toggle="collapse"
                    aria-expanded="false"
                    aria-controls={slug}
                  >
                    click for bio{" "}
                    <img
                      src={`${BASEURL}/images/round-arrow.svg`}
                      className="img-fluid"
                      width="20"
                      height="20"
                      alt="round arrow"
                    />{" "}
                  </button>
                </div>
                <div
                  className={`collapse member-bio-overlay-card ${
                    selectedItem === item.gallery_id ? "show" : ""
                  }`}
                  id={slug}
                  Style={{
                    display:
                      selectedItem === item.gallery_id ? "block" : "none",
                  }}
                >
                  <div className="member-bio-overlay-inner">
                    <button
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      className="bio-close-btn"
                      onClick={() => setSelectedItem(false)}
                    >
                      <img
                        src={`${BASEURL}images/close-icon.svg`}
                        width="20"
                        height="20"
                        alt="close icon"
                      />
                    </button>
                    <div className="member-bio-info">
                      <h4>
                        {name}
                        <span>{title}</span>
                      </h4>
                      <p>{parse(nl2br(item.gallery_description))}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      });
      setPrincipalsData(principalsDiv);
    }
  }, [galleryData, selectedItem]);

  return (
    <div style={{ backgroundColor: "#EFEFEF" }}>
      <Banner />
      <div className="creative-property-main">
        <div className="container">
          {aboutData && parse(aboutData.config_aboutus && aboutData.config_aboutus)}
          {aboutPending && <div className="shimmer-main"><div className="shimmer" style={{minHeight:'32px', display:'block',maxWidth:'508px',borderRadius:'5px',marginBottom:'16px'}}></div> <div className="shimmer" style={{minHeight:'18px',display:'block',width:'100%',marginBottom:'16px'}}></div> <div className="shimmer" style={{minHeight:'18px',display:'block',width:'95%',marginBottom:'16px'}}></div> <div className="shimmer" style={{minHeight:'18px',display:'block',width:'75%',marginBottom:'16px'}}></div> <br/><div className="shimmer" style={{minHeight:'18px',display:'block',width:'100%',marginBottom:'16px'}}></div> <div className="shimmer" style={{minHeight:'18px',display:'block',width:'95%',marginBottom:'16px'}}></div> <div className="shimmer" style={{minHeight:'18px',display:'block',width:'55%',marginBottom:'16px'}}></div>   </div>}
          {aboutError && <p>Error fetching about data: {aboutError}</p>}
        </div>
      </div>
      <div
        className="principal-section"
        style={{
          backgroundImage: `url("${BASEURL}/images/about-us-blue.jpg")`,
        }}
      >
        <div className="container">
          <div className="principal-info-cont">
            <h3>Our Principals</h3>
          </div>
        </div>
      </div>
      <div className="principal-member-main">
        <div className="container">
          <div className="row" id="our_principals">
            {principalsData}
            {galleryPending && <div className="shimmer-main">
               
               <div className="shimmer-wg" style={{maxWidth:'1174px',width:'100%',margin:'0 auto'}}>
                   <div className="row">
                      <div className="shimmer" style={{minHeight:'360px', display:'block',width:'48%',marginRight:'20px'}}></div>
                      <div className="shimmer" style={{minHeight:'360px', display:'block', width:'48%'}}></div>
                    </div>
               </div>
                
              </div>}
            {galleryError && (
              <p>Error fetching principals data: {galleryError}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
